import { SiteSection } from '../SiteSection.js';

/**
 * The questions a salon owner actually asks.
 *
 * Native `<details>`/`<summary>`, which is an accordion the platform already
 * ships: keyboard operable, announced correctly, searchable by the browser's
 * find-in-page even when collapsed, and working with no JavaScript. A
 * hand-built one gets at most two of those.
 *
 * The answers are short and commit to something. "Cela dépend de votre
 * configuration" is not an answer and is how an FAQ becomes decoration.
 */

const QUESTIONS: readonly (readonly [string, string])[] = [
  [
    'Est-ce que je dois changer de numéro ?',
    'Non. Vous gardez le vôtre et mettez en place un renvoi quand vous ne décrochez pas. Vous l’arrêtez en retirant ce renvoi, sans nous prévenir.',
  ],
  [
    'Et si l’assistante se trompe ?',
    'Elle ne devine pas. Quand une demande n’est pas claire, elle pose une question, et si cela ne suffit pas elle transfère. Un rendez-vous pris au hasard coûte plus cher qu’un appel transféré.',
  ],
  [
    'Est-ce que mes clients vont comprendre qu’ils parlent à une machine ?',
    'Oui, et nous ne le cachons pas. L’assistante se présente. Un client qui demande une personne en obtient une.',
  ],
  [
    'Qu’est-ce que vous faites de mes données clients ?',
    'Nous ne les importons pas. Notre base se remplit des personnes qui appellent, et rien d’autre. Les numéros sont chiffrés, et l’enregistrement audio est désactivé par défaut.',
  ],
  [
    'Vous prenez une commission sur mes rendez-vous ?',
    'Non. Aucune commission, ni sur un rendez-vous, ni sur un encaissement. Notre revenu est l’abonnement.',
  ],
  [
    'Combien de temps pour être opérationnel ?',
    'L’installation se fait en une séance : le logiciel de réservation, les horaires, la façon dont l’assistante doit parler, puis un appel de test. Le délai réel dépend de votre opérateur pour le renvoi.',
  ],
  [
    'Ça marche avec mon logiciel de réservation ?',
    'Cela dépend duquel, et nous le disons franchement dans la section Intégrations plutôt que de promettre. Le connecteur Amelia est en bêta ; les autres se décident au cas par cas.',
  ],
];

export function Faq(): React.JSX.Element {
  return (
    <SiteSection title="Questions fréquentes">
      <div className="border-b border-wall-line">
        {QUESTIONS.map(([question, answer]) => (
          <details key={question} className="group border-t border-wall-line">
            <summary className="flex min-h-[44px] cursor-pointer list-none items-center justify-between gap-6 py-5 text-subtitle font-medium text-ink">
              {question}
              <span
                aria-hidden="true"
                className="sign-figure shrink-0 text-sign-sm leading-none text-ink-muted transition-transform duration-fast ease-out group-open:rotate-45"
              >
                +
              </span>
            </summary>
            <p className="max-w-2xl pb-6 text-ui text-ink-muted">{answer}</p>
          </details>
        ))}
      </div>
    </SiteSection>
  );
}
